import React from 'react';
import { FiServer, FiMapPin, FiHash, FiShield, FiExternalLink } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const NetworkProviderIntelligence = ({ provider, isRunning }) => {
  const { ip, isp, asn, location, city, country } = provider;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between px-1">
        <h3 className="text-[10px] font-black uppercase tracking-[0.2em] text-muted flex items-center gap-2">
          <SafeIcon icon={FiServer} className="text-primary" /> Provider Intelligence
        </h3>
        <span className="text-[9px] font-bold text-primary/80 bg-primary/5 px-2 py-0.5 rounded border border-primary/10 uppercase">
          Routing Active
        </span>
      </div>

      <div className="glass-panel rounded-2xl p-4 border border-white/5 space-y-4">
        {/* ISP Header */}
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <div className="text-[10px] text-muted font-bold uppercase tracking-widest">Internet Service Provider</div>
            <div className="text-lg font-black text-white leading-tight">{isp}</div>
          </div>
          <div className="p-2 bg-white/5 rounded-xl border border-white/5">
            <SafeIcon icon={FiShield} size={18} className="text-primary" />
          </div>
        </div>

        <div className="h-px bg-white/5" />

        {/* Grid Stats */}
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1">
            <div className="flex items-center gap-1.5 text-muted">
              <SafeIcon icon={FiHash} size={10} />
              <span className="text-[9px] font-black uppercase tracking-tighter">ASN Node</span>
            </div>
            <div className="text-xs font-mono font-bold text-text">{asn}</div>
          </div>
          <div className="space-y-1 text-right">
            <div className="flex items-center gap-1.5 text-muted justify-end">
              <span className="text-[9px] font-black uppercase tracking-tighter">Public Address</span>
              <SafeIcon icon={FiExternalLink} size={10} />
            </div>
            <div className="text-xs font-mono font-bold text-primary">{ip}</div>
          </div>
        </div>

        {/* Location Footer */}
        <div className="bg-black/40 rounded-xl p-3 border border-white/5 flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center border border-primary/20 shrink-0">
            <SafeIcon icon={FiMapPin} size={14} className="text-primary" />
          </div>
          <div className="min-w-0">
            <div className="text-[9px] text-muted font-bold uppercase tracking-tighter">Routing Origin</div>
            <div className="text-xs font-bold text-text truncate">
              {city ? `${city}, ${country}` : 'Detecting regional node...'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkProviderIntelligence;